import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Mensaje } from "../components/mensajes2";
import { Dimmer } from "../components/spinner";
import useTable from "../components/useTableR";
import { Input } from "../ui/inputs/Input";

const CatalogoTasaImpuesto = (props) => {
  const op = require("../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const headCells = [
    {
      id: "codigo",
      label: "CODIGO",
      width: "50px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",

      fontSize: "10px",
      color: "white",
    },
    {
      id: "tipoexp",
      label: "TIPO EXPENDIO",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",

      fontSize: "10px",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",

      fontSize: "10px",
      color: "white",
    },
  ];
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.codigo.includes(target.value) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const seleccionarRegistros = async () => {
    try {
      setLoading(true);
      const campos = `idtipotasa, codigo, descripcion, monto`;
      const nomtab = "tipotasa";
      const orden = "codigo desc";
      const endpoint =
        op.conexion +
        `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        setRecords(response.data);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Buscar los Registros",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const seleccionarTasa = (item) => {
    const { idtipotasa, codigo, descripcion, monto } = item;
    props.onHideAceptaTasa(idtipotasa, descripcion, codigo, monto);
  };
  const salir = () => {
    props.onHideCancela();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-4 fw-bold text-light m-0">Impuesto de Licores</h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div className="col-4 m-0 p-0">
            <Input placeholder="Buscar" onChange={handleSearch} />
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idtipotasa}
                    style={{ padding: "0", fontSize: "11px" }}
                  >
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center" }}
                    >
                      {item.codigo}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "left" }}
                    >
                      {item.descripcion}
                    </td>

                    <td
                      className="align-baseline"
                      style={{ textAlign: "center" }}
                    >
                      <button
                        className="btn btn-sm btn-info rounded-circle"
                        onClick={() => seleccionarTasa(item)}
                      >
                        <i className="fas fa-check"></i>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          Salir <i className="fw-bold fas ms-2 fa-window-close"></i>
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
};
export default CatalogoTasaImpuesto;
